export enum LocalStorageKey {
  PREVIOUS_ROUTE = "PREVIOUS_ROUTE",
  OPEN_UNRATED_CV_DROPDOWN_CANDIDATE_ID = "OPEN_UNRATED_CV_DROPDOWN_CANDIDATE_ID",
}
